// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"46":"b62315d5","133":"09c36795","252":"a4a07f07","276":"d260dd6d","352":"08894a3a","453":"1d0236e4","469":"5591df04","534":"6e7df71f","643":"3b06b4c4","935":"26a9ef5a","983":"baee6476"}[chunkId] + ".chunk.js";
};